import data from './data'
import details from './details'
import discountsPayments from './discountsPayments'
import summary from './summary'
import history from './history'
import general from './general'
import contact from './contact'
import discountsCharges from './discountsCharges'
import paymentsSpentsOthers from './paymentsSpentsOthers'
import thirdPartyInvoices from './thirdPartyInvoices'
import fundProvision from './fundProvision'
import paymentIndications from './paymentIndications'
import provider from './provider'
import files from './files'
import imported from './imported'
import client from './client'
import customer from './customer'
import agent from './agent'
import searchForm from './searchForm'
import assets from './assets'
import validations from './validations'
import factoring from './factoring'
import certificate from './certificate'
import metadata from './metadata'
import sii from './sii'

export default {
  view: 'Vista de la factura',
  data,
  details,
  discountsPayments,
  summary,
  history,
  general,
  files,
  contact,
  imported,
  discountsCharges,
  paymentsSpentsOthers,
  thirdPartyInvoices,
  fundProvision,
  paymentIndications,
  provider,
  client,
  customer,
  agent,
  searchForm,
  assets,
  validations,
  factoring,
  certificate,
  metadata,
  sii
}
